<template>
  <article class="edittitleBar">
    <TitleBar v-if="isTitle" :title="title"></TitleBar>
    <slot name="first"></slot>
    <div v-if="!(value === undefined && isGuide === false)" class="description">
      <div v-if="value !== undefined" :class="align">
        <span v-html="getValue">{{ value }}</span>
      </div>
      <div v-else-if="isGuide === true" class="not">
        <span>작성된 내용이 없습니다.</span>
      </div>
    </div>
    <slot></slot>
    <UbuttonList v-if="!disable" size="small" align="center" :data="getButton"/>
    <!-- <div class="buttonList" v-if="!disable">
      <Ubutton size="small" :text="buttonText" state="deactive" @click.native="valuechange" />
    </div> -->
  </article>
</template>

<script>
import TitleBar from '@/components/layout/TitleBar.vue'

export default {
  props: {
    title: { type: String, required: true },
    value: {type: String},
    buttonList: {type: Array},
    inputTitle: {type: String},
    inputCount: {type: Number, default: 30},
    align: {type: String, default: 'center'},
    disable: {type: Boolean, default: false},
    multiline: {type: Boolean, default: false},
    isGuide: {type: Boolean, default: true},
    isTitle: {type: Boolean, default: true}
  },
  created () {
  },
  data () {
    return {
    }
  },
  name: 'EditTitleBar',
  computed: {
    buttonText () {
      if (this.value) {
        return '수정하기'
      } else {
        return '작성하기'
      }
    },
    getValue () {
      return this.value.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },
    getButton () {
      if (this.buttonList) {
        this.addButtonListClick()
        if (this.value && this.buttonList.length > 1) {
          return this.buttonList[1]
        } else {
          return this.buttonList[0]
        }
      } else {
        if (this.value) {
          return [{name: '수정하기', state: 'deactive', click: this.valuechange}]
        } else {
          return [{name: '작성하기', state: 'deactive', click: this.valuechange}]
        }
      }
    }
  },
  methods: {
    addButtonListClick () {
      if (this.buttonList) {
        var i, j
        for (i = 0; i < this.buttonList.length; i++) {
          for (j = 0; j < this.buttonList[i].length; j++) {
            if (this.buttonList[i][j].default) {
              this.buttonList[i][j].click = this.valuechange
            }
          }
        }
      }
    },
    valuechange () {
      this.openInputLibrary(this.title + ' ' + this.buttonText, (this.value === undefined) ? '' : this.value, {count: this.inputCount, multiline: this.multiline}, (input) => {
        console.log(input)
        if (input.success) {
          this.$emit('submit', input.value)
          this.$emit('update:value', input.value)
        }
      })
    }
  },
  components: {
    TitleBar
  }
}
</script>

<style scoped>
.edittitleBar {
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
}
.edittitleBar .description {
  margin: 10px 0px;
}
.edittitleBar .description > div {
  display: flex;
  background-color: var(--bg-white);
  padding: 10px;
}
.edittitleBar .description .not {
  background-color: transparent;
  justify-content: center;
  color: var(--text-guide);
}
.edittitleBar .description .center {
  justify-content: center;
}
.edittitleBar .description .left {
  justify-content: flex-start;
  text-align: left;
}
.edittitleBar .description .right {
  justify-content: flex-end;
}
.edittitleBar .buttonList {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/EditTitleBar.vue